export default "/fr/_next/static/assets/images/logo_schemaorg.10d7466bfc3f4a7a9abacbf226d8890b.png";